import React from 'react';

export default () => (
  <svg viewBox="0 0 79.227 79.228" width="24px" height="24px" fill="currentColor">
    <path d="M67.993 11.653a39.839 39.839 0 100 56.339 39.883 39.883 0 000-56.339zm-4.347 51.994a33.695 33.695 0 110-47.651 33.732 33.732 0 010 47.651zm-5.812-8.077a2.252 2.252 0 01-4.134 1.788 14.092 14.092 0 00-13.082-8.269 13.973 13.973 0 00-13.158 8.263 2.253 2.253 0 11-4.16-1.728 18.463 18.463 0 0117.318-11.041A18.59 18.59 0 0157.834 55.57zM24.961 29.039a4.656 4.656 0 114.656 4.661 4.657 4.657 0 01-4.656-4.661zm21.114 0a4.657 4.657 0 114.657 4.661 4.658 4.658 0 01-4.658-4.661z" />
  </svg>
);
